import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface EstadoConfirmacaoPonto {
  visivel: boolean;
  titulo: string;
  nome: string;
  horario: string;
}

@Injectable({ providedIn: 'root' })
export class ServicoConfirmacaoPonto {
  private temporizador?: number;
  private readonly estadoInicial: EstadoConfirmacaoPonto = {
    visivel: false,
    titulo: 'Ponto registrado com sucesso.',
    nome: '',
    horario: ''
  };
  private readonly estadoSubject = new BehaviorSubject<EstadoConfirmacaoPonto>(this.estadoInicial);

  readonly estado$ = this.estadoSubject.asObservable();

  exibir(titulo: string, nome: string, horario = '', duracaoMs = 4000) {
    this.cancelarTemporizador();
    this.estadoSubject.next({ visivel: true, titulo, nome, horario });
    this.temporizador = window.setTimeout(() => this.limpar(), duracaoMs);
  }

  limpar() {
    this.cancelarTemporizador();
    this.estadoSubject.next(this.estadoInicial);
  }

  private cancelarTemporizador() {
    if (this.temporizador) {
      window.clearTimeout(this.temporizador);
      this.temporizador = undefined;
    }
  }
}
